import cabinetStyle from "./MentorCabinet.module.css";
import React, {useEffect, useState} from "react";
import PlayerSetup from "./PlayerSetup";
import {v4 as uuid} from "uuid";
import {useTranslation} from "react-i18next";

let defaultPlayers = [{
    identifier: uuid(),
    playerName: '',
    isAutoDice: true,
    color: "#bc1a1a",
    chipName: ""
}, {
    identifier: uuid(),
    playerName: '',
    isAutoDice: true,
    color: "#bc1a1a",
    chipName: ""
}]

function PlayersListSetup(props) {
    const [players, setPlayers] = useState(defaultPlayers)
    const { t } = useTranslation('translation', { keyPrefix: 'groupGamePlayers' });

    const minNumberOfPlayers = 2
    const maxNumberOfPlayers = 6

    function Add(item) {
        let oldPlayers = [...players]
        let newPlayer = {
            identifier: uuid(),
            playerName: '',
            isAutoDice: true,
            color: "#000000",
            chipName: ''
        }
        oldPlayers.push(newPlayer)

        setPlayers(oldPlayers)
    }

    const removePlayer = (identifier) => {
        if (players.length > minNumberOfPlayers) {
            let updatedPlayers = players.filter(p => p.identifier !== identifier)
            setPlayers(updatedPlayers);
        }
    };

    function updatePlayerName(identifier, newPlayerName) {
        let oldPlayers = [...players]

        oldPlayers.forEach(player => {
            if (player.identifier === identifier) {
                player.playerName = newPlayerName
            }
        })

        setPlayers(oldPlayers)
    }

    function updatePlayerDice(identifier, isAutoDiceNew) {
        let oldPlayers = [...players]

        oldPlayers.forEach(player => {
            if (player.identifier === identifier) {
                player.isAutoDice = isAutoDiceNew
            }
        })

        setPlayers(oldPlayers)
    }

    function updateColor(identifier, newColor) {
        let oldPlayers = [...players]

        oldPlayers.forEach(player => {
            if (player.identifier === identifier) {
                player.color = newColor
            }
        })

        setPlayers(oldPlayers)
    }

    function updateChipName(identifier, newChipName) {
        let oldPlayers = [...players]

        oldPlayers.forEach(player => {
            if (player.identifier === identifier) {
                player.chipName = newChipName
            }
        })

        setPlayers(oldPlayers)
    }

    useEffect(() => {
        let errors = 0
        players.forEach(player => {
            if (player.playerName.trim() === "" || player.chipName.trim() === "") {
                errors++
            }
        })
        props.setPlayers([...players])
        if (errors > 0) {
            props.setPlayersReady(false)
        } else {
            props.setPlayersReady(true)
        }
    }, [players])

    return (
        <>
            {players.map((player) => (

                <div
                    style={{
                        display: "flex",
                        flexDirection: "rows",
                        marginLeft: undefined
                    }}
                    key={player.identifier}
                >
                    <PlayerSetup
                        identifier={player.identifier}
                        playerName={player.playerName}
                        isAutoDice={player.isAutoDice}
                        color={player.color}
                        chipName={player.chipName}
                        updatePlayerName={updatePlayerName}
                        updatePlayerDice={updatePlayerDice}
                        updateColor={updateColor}
                        updateChipName={updateChipName}
                        playerDeleter={removePlayer}
                    ></PlayerSetup>
                </div>
            ))}

            {
                (players.length < maxNumberOfPlayers && players.length >= minNumberOfPlayers) &&
                <div style={{display: "flex", justifyContent: "center", marginBottom: "12px"}}>
                    <button className={`${cabinetStyle.confirmCreateNewGame} ${cabinetStyle.sideBarText}`}
                            id={"saveButton"}
                            onClick={Add}
                    >{t('addPlayerButton')}
                    </button>
                </div>

            }
        </>


    )
}

export default PlayersListSetup